import { action } from '@ember/object';
import type Owner from '@ember/owner';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import FormCheckboxComponent from 'webapp/components/form/checkbox';
import FormInputComponent from 'webapp/components/form/input';

import type BoardLoop from 'webapp/models-custom/board-loop';

interface Args {
	model: BoardLoop;
	onChange?: () => void;
}

export default class BoardLoopsDelayInputComponent extends Component<Args> {
	minLoopDelay = 3;
	maxLoopDelay = 99999999;

	@tracked isAutoLoop = false;
	@tracked loopDelay = 60;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		const model = this.args.model;

		this.isAutoLoop = model.isAutoLoop;
		if (model.loopDelay) {
			this.loopDelay = model.loopDelay;
		}
	}

	get isLoopDelayDisabled(): boolean {
		return !this.isAutoLoop;
	}

	@action
	changeAutoLoop(isAutoLoop: boolean): void {
		this.isAutoLoop = isAutoLoop;
		this.updateLoopDelay();
	}

	@action
	updateLoopDelay(): void {
		this.isAutoLoop = this.isAutoLoop && !!this.loopDelay;
		if (this.loopDelay < this.minLoopDelay) {
			this.loopDelay = this.minLoopDelay;
		}
		this.args.model.loopDelay = this.isAutoLoop ? this.loopDelay : 0;
		if (this.args.onChange) {
			this.args.onChange();
		}
	}
	<template>
		<div class="row delay-input">
			<FormCheckboxComponent
				@name="autoLoop"
				@selected={{this.isAutoLoop}}
				@label="Loop every:"
				@onChange={{this.changeAutoLoop}}
			/>
			<FormInputComponent
				name="loop"
				type="number"
				disabled={{this.isLoopDelayDisabled}}
				required={{true}}
				min={{this.minLoopDelay}}
				max={{this.maxLoopDelay}}
				@value={{this.loopDelay}}
				@focusOut={{this.updateLoopDelay}}
				@loseFocusOnEnter={{true}}
				@hideFloatLabel={{true}}
			/>
			<span class="text">seconds</span>
		</div>
	</template>
}
